

























import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    IconBase
  }
})
export default class ButtonCount extends Vue {
  @Prop({ type: String, required: false, default: "button" }) tag!: string;
  @Prop({ type: String, required: false, default: "plus" }) kind!: string;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;

  emitClickEvent() {
    this.$emit("click-button");
  }
}
